"use client";
import"react";var n;!function(n){n.ios="iOS",n.android="android",n.desktop="desktop",n.unknown="unknown"}(n||(n={}));export{n as DeviceTypes};
